import { Country } from '../country/Country'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum DialCodeId {
  AFG = 1,
  ALB = 2,
  DZA = 3,
  ASM = 4,
  AND = 5,
  AGO = 6,
  AIA = 7,
  ATA = 8,
  ATG = 9,
  ARG = 10,
  ARM = 11,
  ABW = 12,
  AUS = 13,
  AUT = 14,
  AZE = 15,
  BHS = 16,
  BHR = 17,
  BGD = 18,
  BRB = 19,
  BLR = 20,
  BEL = 21,
  BLZ = 22,
  BEN = 23,
  BMU = 24,
  BTN = 25,
  BOL = 26,
  BIH = 27,
  BWA = 28,
  BRA = 29,
  IOT = 30,
  VGB = 31,
  BRN = 32,
  BGR = 33,
  BFA = 34,
  BDI = 35,
  KHM = 36,
  CMR = 37,
  CAN = 38,
  CPV = 39,
  CYM = 40,
  CAF = 41,
  TCD = 42,
  CHL = 43,
  CHN = 44,
  CXR = 45,
  CCK = 46,
  COL = 47,
  COM = 48,
  COG = 49,
  COD = 50,
  COK = 51,
  CRI = 52,
  HRV = 53,
  CUB = 54,
  CUW = 55,
  CYP = 56,
  CZE = 57,
  CIV = 58,
  DNK = 59,
  DJI = 60,
  DMA = 61,
  DOM_1 = 62,
  DOM_2 = 63,
  DOM_3 = 64,
  TLS = 65,
  ECU = 66,
  EGY = 67,
  SLV = 68,
  GNQ = 69,
  ERI = 70,
  EST = 71,
  ETH = 72,
  FLK = 73,
  FRO = 74,
  FJI = 75,
  FIN = 76,
  FRA = 77,
  PYF = 78,
  GAB = 79,
  GMB = 80,
  GEO = 81,
  DEU = 82,
  GHA = 83,
  GIB = 84,
  GRC = 85,
  GRL = 86,
  GRD = 87,
  GLP = 88,
  GUM = 89,
  GTM = 90,
  GGY = 91,
  GIN = 92,
  GNB = 93,
  GUY = 94,
  HTI = 95,
  HND = 96,
  HKG = 97,
  HUN = 98,
  ISL = 99,
  IND = 100,
  IDN = 101,
  IRN = 102,
  IRQ = 103,
  IRL = 104,
  IMN = 105,
  ISR = 106,
  ITA = 107,
  JAM = 108,
  JPN = 109,
  JEY = 110,
  JOR = 111,
  KAZ = 112,
  KEN = 113,
  KIR = 114,
  XKX = 115,
  KWT = 116,
  KGZ = 117,
  LAO = 118,
  LVA = 119,
  LBN = 120,
  LSO = 121,
  LBR = 122,
  LBY = 123,
  LIE = 124,
  LTU = 125,
  LUX = 126,
  MAC = 127,
  MDG = 129,
  MWI = 130,
  MYS = 131,
  MDV = 132,
  MLI = 133,
  MLT = 134,
  MHL = 135,
  MTQ = 136,
  MRT = 137,
  MUS = 138,
  MYT = 139,
  MEX = 140,
  FSM = 141,
  MDA = 142,
  MCO = 143,
  MNG = 144,
  MNE = 145,
  MSR = 146,
  MAR = 147,
  MOZ = 148,
  MMR = 149,
  NAM = 150,
  NRU = 151,
  NPL = 152,
  NLD = 153,
  NCL = 154,
  NZL = 155,
  NIC = 156,
  NER = 157,
  NGA = 158,
  NIU = 159,
  MNP = 161,
  NOR = 162,
  OMN = 163,
  PAK = 164,
  PLW = 165,
  PAN = 167,
  PNG = 168,
  PRY = 169,
  PER = 170,
  PHL = 171,
  PCN = 172,
  POL = 173,
  PRT = 174,
  PRI = 175,
  QAT = 176,
  REU = 177,
  ROU = 178,
  RUS = 179,
  RWA = 180,
  BLM = 181,
  SHN = 182,
  KNA = 183,
  LCA = 184,
  MAF = 185,
  SPM = 186,
  VCT = 187,
  WSM = 188,
  SMR = 189,
  STP = 190,
  SAU = 191,
  SEN = 192,
  SRB = 193,
  SYC = 194,
  SLE = 195,
  SGP = 196,
  SXM = 197,
  SVK = 198,
  SVN = 199,
  SLB = 200,
  SOM = 201,
  ZAF = 202,
  KOR = 203,
  SSD = 204,
  ESP = 205,
  LKA = 206,
  SDN = 207,
  SUR = 208,
  SJM = 209,
  SWZ = 210,
  SWE = 211,
  CHE = 212,
  SYR = 213,
  TWN = 214,
  TJK = 215,
  TZA = 216,
  THA = 217,
  TGO = 218,
  TKL = 219,
  TON = 220,
  TTO = 221,
  TUN = 222,
  TUR = 223,
  TKM = 224,
  TCA = 225,
  TUV = 226,
  UGA = 228,
  UKR = 229,
  ARE = 230,
  GBR = 231,
  USA = 232,
  URY = 233,
  UZB = 234,
  VUT = 235,
  VAT = 236,
  VEN = 237,
  VNM = 238,
  WLF = 239,
  ESH = 240,
  YEM = 241,
  ZMB = 242,
  ZWE = 243,
}

export class DialCode {
  static AFG = new DialCode(DialCodeId.AFG, '+93', Country.AFG)
  static ALB = new DialCode(DialCodeId.ALB, '+355', Country.ALB)
  static DZA = new DialCode(DialCodeId.DZA, '+213', Country.DZA)
  static ASM = new DialCode(DialCodeId.ASM, '+1-684', Country.USA)
  static AND = new DialCode(DialCodeId.AND, '+376', Country.AND)
  static AGO = new DialCode(DialCodeId.AGO, '+244', Country.AGO)
  static AIA = new DialCode(DialCodeId.AIA, '+1-264', Country.AIA)
  static ATA = new DialCode(DialCodeId.ATA, '+672', Country.ATA)
  static ATG = new DialCode(DialCodeId.ATG, '+1-268', Country.ATG)
  static ARG = new DialCode(DialCodeId.ARG, '+54', Country.ARG)
  static ARM = new DialCode(DialCodeId.ARM, '+374', Country.ARM)
  static ABW = new DialCode(DialCodeId.ABW, '+297', Country.ABW)
  static AUS = new DialCode(DialCodeId.AUS, '+61', Country.AUS)
  static AUT = new DialCode(DialCodeId.AUT, '+43', Country.AUT)
  static AZE = new DialCode(DialCodeId.AZE, '+994', Country.AZE)
  static BHS = new DialCode(DialCodeId.BHS, '+1-242', Country.BHS)
  static BHR = new DialCode(DialCodeId.BHR, '+973', Country.BHR)
  static BGD = new DialCode(DialCodeId.BGD, '+880', Country.BGD)
  static BRB = new DialCode(DialCodeId.BRB, '+1-246', Country.BRB)
  static BLR = new DialCode(DialCodeId.BLR, '+375', Country.BLR)
  static BEL = new DialCode(DialCodeId.BEL, '+32', Country.BEL)
  static BLZ = new DialCode(DialCodeId.BLZ, '+501', Country.BLZ)
  static BEN = new DialCode(DialCodeId.BEN, '+229', Country.BEN)
  static BMU = new DialCode(DialCodeId.BMU, '+1-441', Country.BMU)
  static BTN = new DialCode(DialCodeId.BTN, '+975', Country.BTN)
  static BOL = new DialCode(DialCodeId.BOL, '+591', Country.BOL)
  static BIH = new DialCode(DialCodeId.BIH, '+387', Country.BIH)
  static BWA = new DialCode(DialCodeId.BWA, '+267', Country.BWA)
  static BRA = new DialCode(DialCodeId.BRA, '+55', Country.BRA)
  static IOT = new DialCode(DialCodeId.IOT, '+246', Country.IOT)
  static VGB = new DialCode(DialCodeId.VGB, '+1-284', Country.VGB)
  static BRN = new DialCode(DialCodeId.BRN, '+673', Country.BRN)
  static BGR = new DialCode(DialCodeId.BGR, '+359', Country.BGR)
  static BFA = new DialCode(DialCodeId.BFA, '+226', Country.BFA)
  static BDI = new DialCode(DialCodeId.BDI, '+257', Country.BDI)
  static KHM = new DialCode(DialCodeId.KHM, '+855', Country.KHM)
  static CMR = new DialCode(DialCodeId.CMR, '+237', Country.CMR)
  static CAN = new DialCode(DialCodeId.CAN, '+1', Country.CAN)
  static CPV = new DialCode(DialCodeId.CPV, '+238', Country.CPV)
  static CYM = new DialCode(DialCodeId.CYM, '+1-345', Country.CYM)
  static CAF = new DialCode(DialCodeId.CAF, '+236', Country.CAF)
  static TCD = new DialCode(DialCodeId.TCD, '+235', Country.TCD)
  static CHL = new DialCode(DialCodeId.CHL, '+56', Country.CHL)
  static CHN = new DialCode(DialCodeId.CHN, '+86', Country.CHN)
  static CXR = new DialCode(DialCodeId.CXR, '+61', Country.CXR)
  static CCK = new DialCode(DialCodeId.CCK, '+61', Country.CCK)
  static COL = new DialCode(DialCodeId.COL, '+57', Country.COL)
  static COM = new DialCode(DialCodeId.COM, '+269', Country.COM)
  static COK = new DialCode(DialCodeId.COK, '+682', Country.COK)
  static CRI = new DialCode(DialCodeId.CRI, '+506', Country.CRI)
  static CIV = new DialCode(DialCodeId.CIV, '+225', Country.CIV)
  static HRV = new DialCode(DialCodeId.HRV, '+385', Country.HRV)
  static CUB = new DialCode(DialCodeId.CUB, '+53', Country.CUB)
  static SVN = new DialCode(DialCodeId.SVN, '+386', Country.SVN)
  static CYP = new DialCode(DialCodeId.CYP, '+357', Country.CYP)
  static CZE = new DialCode(DialCodeId.CZE, '+420', Country.CZE)
  static COD = new DialCode(DialCodeId.COD, '+243', Country.COD)
  static DNK = new DialCode(DialCodeId.DNK, '+45', Country.DNK)
  static DJI = new DialCode(DialCodeId.DJI, '+253', Country.DJI)
  static DMA = new DialCode(DialCodeId.DMA, '+1-767', Country.DMA)
  static ECU = new DialCode(DialCodeId.ECU, '+593', Country.ECU)
  static EGY = new DialCode(DialCodeId.EGY, '+20', Country.EGY)
  static SLV = new DialCode(DialCodeId.SLV, '+503', Country.SLV)
  static GNQ = new DialCode(DialCodeId.GNQ, '+240', Country.GNQ)
  static ERI = new DialCode(DialCodeId.ERI, '+291', Country.ERI)
  static EST = new DialCode(DialCodeId.EST, '+372', Country.EST)
  static ETH = new DialCode(DialCodeId.ETH, '+251', Country.ETH)
  static FLK = new DialCode(DialCodeId.FLK, '+500', Country.FLK)
  static FRO = new DialCode(DialCodeId.FRO, '+298', Country.FRO)
  static FJI = new DialCode(DialCodeId.FJI, '+679', Country.FJI)
  static FIN = new DialCode(DialCodeId.FIN, '+358', Country.FIN)
  static FRA = new DialCode(DialCodeId.FRA, '+33', Country.FRA)
  static PYF = new DialCode(DialCodeId.PYF, '+689', Country.PYF)
  static GAB = new DialCode(DialCodeId.GAB, '+241', Country.GAB)
  static GMB = new DialCode(DialCodeId.GMB, '+220', Country.GMB)
  static GEO = new DialCode(DialCodeId.GEO, '+995', Country.GEO)
  static DEU = new DialCode(DialCodeId.DEU, '+49', Country.DEU)
  static GHA = new DialCode(DialCodeId.GHA, '+233', Country.GHA)
  static GIB = new DialCode(DialCodeId.GIB, '+350', Country.GIB)
  static GRC = new DialCode(DialCodeId.GRC, '+30', Country.GRC)
  static GRL = new DialCode(DialCodeId.GRL, '+299', Country.GRL)
  static GRD = new DialCode(DialCodeId.GRD, '+1-473', Country.GRD)
  static GLP = new DialCode(DialCodeId.GLP, '+590', Country.GLP)
  static GUM = new DialCode(DialCodeId.GUM, '+1-671', Country.GUM)
  static GTM = new DialCode(DialCodeId.GTM, '+502', Country.GTM)
  static GGY = new DialCode(DialCodeId.GGY, '+44', Country.GGY)
  static GIN = new DialCode(DialCodeId.GIN, '+224', Country.GIN)
  static GNB = new DialCode(DialCodeId.GNB, '+245', Country.GNB)
  static GUY = new DialCode(DialCodeId.GUY, '+592', Country.GUY)
  static HTI = new DialCode(DialCodeId.HTI, '+509', Country.HTI)
  static HND = new DialCode(DialCodeId.HND, '+504', Country.HND)
  static HKG = new DialCode(DialCodeId.HKG, '+852', Country.HKG)
  static HUN = new DialCode(DialCodeId.HUN, '+36', Country.HUN)
  static ISL = new DialCode(DialCodeId.ISL, '+354', Country.ISL)
  static IND = new DialCode(DialCodeId.IND, '+91', Country.IND)
  static IDN = new DialCode(DialCodeId.IDN, '+62', Country.IDN)
  static IRN = new DialCode(DialCodeId.IRN, '+98', Country.IRN)
  static IRQ = new DialCode(DialCodeId.IRQ, '+964', Country.IRQ)
  static IRL = new DialCode(DialCodeId.IRL, '+353', Country.IRL)
  static IMN = new DialCode(DialCodeId.IMN, '+44', Country.IMN)
  static ISR = new DialCode(DialCodeId.ISR, '+972', Country.ISR)
  static ITA = new DialCode(DialCodeId.ITA, '+39', Country.ITA)
  static JAM = new DialCode(DialCodeId.JAM, '+1-876', Country.JAM)
  static JPN = new DialCode(DialCodeId.JPN, '+81', Country.JPN)
  static JEY = new DialCode(DialCodeId.JEY, '+44', Country.JEY)
  static JOR = new DialCode(DialCodeId.JOR, '+962', Country.JOR)
  static KAZ = new DialCode(DialCodeId.KAZ, '+7', Country.KAZ)
  static KEN = new DialCode(DialCodeId.KEN, '+254', Country.KEN)
  static KIR = new DialCode(DialCodeId.KIR, '+686', Country.KIR)
  static XXK = new DialCode(DialCodeId.XKX, '+383', Country.XKX)
  static KWT = new DialCode(DialCodeId.KWT, '+965', Country.KWT)
  static KGZ = new DialCode(DialCodeId.KGZ, '+996', Country.KGZ)
  static LAO = new DialCode(DialCodeId.LAO, '+856', Country.LAO)
  static LVA = new DialCode(DialCodeId.LVA, '+371', Country.LVA)
  static LBN = new DialCode(DialCodeId.LBN, '+961', Country.LBN)
  static LSO = new DialCode(DialCodeId.LSO, '+266', Country.LSO)
  static LBR = new DialCode(DialCodeId.LBR, '+231', Country.LBR)
  static LBY = new DialCode(DialCodeId.LBY, '+218', Country.LBY)
  static LIE = new DialCode(DialCodeId.LIE, '+423', Country.LIE)
  static LTU = new DialCode(DialCodeId.LTU, '+370', Country.LTU)
  static LUX = new DialCode(DialCodeId.LUX, '+352', Country.LUX)
  static MAC = new DialCode(DialCodeId.MAC, '+853', Country.MAC)
  static MDG = new DialCode(DialCodeId.MDG, '+261', Country.MDG)
  static MWI = new DialCode(DialCodeId.MWI, '+265', Country.MWI)
  static MYS = new DialCode(DialCodeId.MYS, '+60', Country.MYS)
  static MDV = new DialCode(DialCodeId.MDV, '+960', Country.MDV)
  static MLI = new DialCode(DialCodeId.MLI, '+223', Country.MLI)
  static MLT = new DialCode(DialCodeId.MLT, '+356', Country.MLT)
  static MHL = new DialCode(DialCodeId.MHL, '+692', Country.MHL)
  static MTQ = new DialCode(DialCodeId.MTQ, '+596', Country.MTQ)
  static MRT = new DialCode(DialCodeId.MRT, '+222', Country.MRT)
  static MUS = new DialCode(DialCodeId.MUS, '+230', Country.MUS)
  static MYT = new DialCode(DialCodeId.MYT, '+262', Country.MYT)
  static MEX = new DialCode(DialCodeId.MEX, '+52', Country.MEX)
  static FSM = new DialCode(DialCodeId.FSM, '+691', Country.FSM)
  static MDA = new DialCode(DialCodeId.MDA, '+373', Country.MDA)
  static MCO = new DialCode(DialCodeId.MCO, '+377', Country.MCO)
  static MNG = new DialCode(DialCodeId.MNG, '+976', Country.MNG)
  static MNE = new DialCode(DialCodeId.MNE, '+382', Country.MNE)
  static MSR = new DialCode(DialCodeId.MSR, '+1-664', Country.MSR)
  static MAR = new DialCode(DialCodeId.MAR, '+212', Country.MAR)
  static MOZ = new DialCode(DialCodeId.MOZ, '+258', Country.MOZ)
  static MMR = new DialCode(DialCodeId.MMR, '+95', Country.MMR)
  static NAM = new DialCode(DialCodeId.NAM, '+264', Country.NAM)
  static NRU = new DialCode(DialCodeId.NRU, '+674', Country.NRU)
  static NPL = new DialCode(DialCodeId.NPL, '+977', Country.NPL)
  static NLD = new DialCode(DialCodeId.NLD, '+31', Country.NLD)
  static NCL = new DialCode(DialCodeId.NCL, '+687', Country.NCL)
  static NZL = new DialCode(DialCodeId.NZL, '+64', Country.NZL)
  static NIC = new DialCode(DialCodeId.NIC, '+505', Country.NIC)
  static NER = new DialCode(DialCodeId.NER, '+227', Country.NER)
  static NGA = new DialCode(DialCodeId.NGA, '+234', Country.NGA)
  static NIU = new DialCode(DialCodeId.NIU, '+683', Country.NIU)
  static MNP = new DialCode(DialCodeId.MNP, '+1-670', Country.MNP)
  static NOR = new DialCode(DialCodeId.NOR, '+47', Country.NOR)
  static OMN = new DialCode(DialCodeId.OMN, '+968', Country.OMN)
  static PAK = new DialCode(DialCodeId.PAK, '+92', Country.PAK)
  static PLW = new DialCode(DialCodeId.PLW, '+680', Country.PLW)
  static PAN = new DialCode(DialCodeId.PAN, '+507', Country.PAN)
  static PNG = new DialCode(DialCodeId.PNG, '+675', Country.PNG)
  static PRY = new DialCode(DialCodeId.PRY, '+595', Country.PRY)
  static PER = new DialCode(DialCodeId.PER, '+51', Country.PER)
  static PHL = new DialCode(DialCodeId.PHL, '+63', Country.PHL)
  static PCN = new DialCode(DialCodeId.PCN, '+870', Country.PCN)
  static POL = new DialCode(DialCodeId.POL, '+48', Country.POL)
  static PRT = new DialCode(DialCodeId.PRT, '+351', Country.PRT)
  static PRI = new DialCode(DialCodeId.PRI, '+1-787', Country.PRI)
  static QAT = new DialCode(DialCodeId.QAT, '+974', Country.QAT)
  static ROU = new DialCode(DialCodeId.ROU, '+40', Country.ROU)
  static RUS = new DialCode(DialCodeId.RUS, '+7', Country.RUS)
  static RWA = new DialCode(DialCodeId.RWA, '+250', Country.RWA)
  static REU = new DialCode(DialCodeId.REU, '+262', Country.REU)
  static BLM = new DialCode(DialCodeId.BLM, '+590', Country.BLM)
  static SHN = new DialCode(DialCodeId.SHN, '+290', Country.SHN)
  static KNA = new DialCode(DialCodeId.KNA, '+1-869', Country.KNA)
  static LCA = new DialCode(DialCodeId.LCA, '+1-758', Country.LCA)
  static MAF = new DialCode(DialCodeId.MAF, '+590', Country.MAF)
  static SPM = new DialCode(DialCodeId.SPM, '+508', Country.SPM)
  static VCT = new DialCode(DialCodeId.VCT, '+1-784', Country.VCT)
  static WSM = new DialCode(DialCodeId.WSM, '+685', Country.WSM)
  static SMR = new DialCode(DialCodeId.SMR, '+378', Country.SMR)
  static STP = new DialCode(DialCodeId.STP, '+239', Country.STP)
  static SAU = new DialCode(DialCodeId.SAU, '+966', Country.SAU)
  static SEN = new DialCode(DialCodeId.SEN, '+221', Country.SEN)
  static SRB = new DialCode(DialCodeId.SRB, '+381', Country.SRB)
  static SYC = new DialCode(DialCodeId.SYC, '+248', Country.SYC)
  static SLE = new DialCode(DialCodeId.SLE, '+232', Country.SLE)
  static SGP = new DialCode(DialCodeId.SGP, '+65', Country.SGP)
  static SXM = new DialCode(DialCodeId.SXM, '+1-721', Country.SXM)
  static ARE = new DialCode(DialCodeId.ARE, '+971', Country.ARE)
  static GBR = new DialCode(DialCodeId.GBR, '+44', Country.GBR)
  static USA = new DialCode(DialCodeId.USA, '+1', Country.USA)
  static URY = new DialCode(DialCodeId.URY, '+598', Country.URY)
  static UZB = new DialCode(DialCodeId.UZB, '+998', Country.UZB)
  static VUT = new DialCode(DialCodeId.VUT, '+678', Country.VUT)
  static VEN = new DialCode(DialCodeId.VEN, '+58', Country.VEN)
  static VNM = new DialCode(DialCodeId.VNM, '+84', Country.VNM)
  static WLF = new DialCode(DialCodeId.WLF, '+681', Country.WLF)
  static ESH = new DialCode(DialCodeId.ESH, '+212', Country.ESH)
  static YEM = new DialCode(DialCodeId.YEM, '+967', Country.YEM)
  static ZMB = new DialCode(DialCodeId.ZMB, '+260', Country.ZMB)
  static ZWE = new DialCode(DialCodeId.ZWE, '+263', Country.ZWE)
  static SLB = new DialCode(DialCodeId.SLB, '+677', Country.SLB)
  static SOM = new DialCode(DialCodeId.SOM, '+252', Country.SOM)
  static ZAF = new DialCode(DialCodeId.ZAF, '+27', Country.ZAF)
  static KOR = new DialCode(DialCodeId.KOR, '+82', Country.KOR)
  static SSD = new DialCode(DialCodeId.SSD, '+211', Country.SSD)
  static ESP = new DialCode(DialCodeId.ESP, '+34', Country.ESP)
  static LKA = new DialCode(DialCodeId.LKA, '+94', Country.LKA)
  static SDN = new DialCode(DialCodeId.SDN, '+249', Country.SDN)
  static SUR = new DialCode(DialCodeId.SUR, '+597', Country.SUR)
  static SJM = new DialCode(DialCodeId.SJM, '+47', Country.SJM)
  static SWZ = new DialCode(DialCodeId.SWZ, '+268', Country.SWZ)
  static SWE = new DialCode(DialCodeId.SWE, '+46', Country.SWE)
  static CHE = new DialCode(DialCodeId.CHE, '+41', Country.CHE)
  static SYR = new DialCode(DialCodeId.SYR, '+963', Country.SYR)
  static TJK = new DialCode(DialCodeId.TJK, '+992', Country.TJK)
  static TZA = new DialCode(DialCodeId.TZA, '+255', Country.TZA)
  static THA = new DialCode(DialCodeId.THA, '+66', Country.THA)
  static TLS = new DialCode(DialCodeId.TLS, '+670', Country.TLS)
  static TGO = new DialCode(DialCodeId.TGO, '+228', Country.TGO)
  static TKL = new DialCode(DialCodeId.TKL, '+690', Country.TKL)
  static TON = new DialCode(DialCodeId.TON, '+676', Country.TON)
  static TTO = new DialCode(DialCodeId.TTO, '+1-868', Country.TTO)
  static TUN = new DialCode(DialCodeId.TUN, '+216', Country.TUN)
  static TKM = new DialCode(DialCodeId.TKM, '+993', Country.TKM)
  static TCA = new DialCode(DialCodeId.TCA, '+1-649', Country.TCA)
  static TUV = new DialCode(DialCodeId.TUV, '+688', Country.TUV)
  static UGA = new DialCode(DialCodeId.UGA, '+256', Country.UGA)
  static DOM_1 = new DialCode(DialCodeId.DOM_1, '+1-809', Country.DOM)
  static DOM_2 = new DialCode(DialCodeId.DOM_2, '+1-829', Country.DOM)
  static DOM_3 = new DialCode(DialCodeId.DOM_3, '+1-849', Country.DOM)
  static UKR = new DialCode(DialCodeId.UKR, '+380', Country.UKR)
  static TWN = new DialCode(DialCodeId.TWN, '+886', Country.TWN)
  static SVK = new DialCode(DialCodeId.SVK, '+421', Country.SVK)
  static TUR = new DialCode(DialCodeId.TUR, '+90', Country.TUR)
  static CUW = new DialCode(DialCodeId.CUW, '+599', Country.CUW)

  private constructor(
    public readonly id: DialCodeId,
    public readonly dialCode: string,
    public readonly country: Country,
  ) {}

  static getById = (id: DialCodeId): DialCode => {
    const value = DialCode.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(DialCode.name, id)
    }

    return value
  }

  static all = (): DialCode[] => {
    return [
      DialCode.AFG,
      DialCode.ALB,
      DialCode.DZA,
      DialCode.ASM,
      DialCode.AND,
      DialCode.AGO,
      DialCode.AIA,
      DialCode.ATA,
      DialCode.ATG,
      DialCode.ARG,
      DialCode.ARM,
      DialCode.ABW,
      DialCode.AUS,
      DialCode.AUT,
      DialCode.AZE,
      DialCode.BHS,
      DialCode.BHR,
      DialCode.BGD,
      DialCode.BRB,
      DialCode.BLR,
      DialCode.BEL,
      DialCode.BLZ,
      DialCode.BEN,
      DialCode.BMU,
      DialCode.BTN,
      DialCode.BOL,
      DialCode.BIH,
      DialCode.BWA,
      DialCode.BRA,
      DialCode.IOT,
      DialCode.VGB,
      DialCode.BRN,
      DialCode.BGR,
      DialCode.BFA,
      DialCode.BDI,
      DialCode.KHM,
      DialCode.CMR,
      DialCode.CAN,
      DialCode.CPV,
      DialCode.CYM,
      DialCode.CAF,
      DialCode.TCD,
      DialCode.CHL,
      DialCode.CHN,
      DialCode.CXR,
      DialCode.CCK,
      DialCode.COL,
      DialCode.COM,
      DialCode.COD,
      DialCode.COK,
      DialCode.CRI,
      DialCode.HRV,
      DialCode.CUB,
      DialCode.CYP,
      DialCode.CZE,
      DialCode.CIV,
      DialCode.DNK,
      DialCode.DJI,
      DialCode.DMA,
      DialCode.TLS,
      DialCode.ECU,
      DialCode.EGY,
      DialCode.SLV,
      DialCode.GNQ,
      DialCode.ERI,
      DialCode.EST,
      DialCode.ETH,
      DialCode.FLK,
      DialCode.FRO,
      DialCode.FJI,
      DialCode.FIN,
      DialCode.FRA,
      DialCode.PYF,
      DialCode.GAB,
      DialCode.GMB,
      DialCode.GEO,
      DialCode.DEU,
      DialCode.GHA,
      DialCode.GIB,
      DialCode.GRC,
      DialCode.GRL,
      DialCode.GRD,
      DialCode.GLP,
      DialCode.GUM,
      DialCode.GTM,
      DialCode.GGY,
      DialCode.GIN,
      DialCode.GNB,
      DialCode.GUY,
      DialCode.HTI,
      DialCode.HND,
      DialCode.HKG,
      DialCode.HUN,
      DialCode.ISL,
      DialCode.IND,
      DialCode.IDN,
      DialCode.IRN,
      DialCode.IRQ,
      DialCode.IRL,
      DialCode.IMN,
      DialCode.ISR,
      DialCode.ITA,
      DialCode.JAM,
      DialCode.JPN,
      DialCode.JEY,
      DialCode.JOR,
      DialCode.KAZ,
      DialCode.KEN,
      DialCode.KIR,
      DialCode.XXK,
      DialCode.KWT,
      DialCode.KGZ,
      DialCode.LAO,
      DialCode.LVA,
      DialCode.LBN,
      DialCode.LSO,
      DialCode.LBR,
      DialCode.LBY,
      DialCode.LIE,
      DialCode.LTU,
      DialCode.LUX,
      DialCode.MAC,
      DialCode.MDG,
      DialCode.MWI,
      DialCode.MYS,
      DialCode.MDV,
      DialCode.MLI,
      DialCode.MLT,
      DialCode.MHL,
      DialCode.MTQ,
      DialCode.MRT,
      DialCode.MUS,
      DialCode.MYT,
      DialCode.MEX,
      DialCode.FSM,
      DialCode.MDA,
      DialCode.MCO,
      DialCode.MNG,
      DialCode.MNE,
      DialCode.MSR,
      DialCode.MAR,
      DialCode.MOZ,
      DialCode.MMR,
      DialCode.NAM,
      DialCode.NRU,
      DialCode.NPL,
      DialCode.NLD,
      DialCode.NCL,
      DialCode.NZL,
      DialCode.NIC,
      DialCode.NER,
      DialCode.NGA,
      DialCode.NIU,
      DialCode.MNP,
      DialCode.NOR,
      DialCode.OMN,
      DialCode.PAK,
      DialCode.PLW,
      DialCode.PAN,
      DialCode.PNG,
      DialCode.PRY,
      DialCode.PER,
      DialCode.PHL,
      DialCode.PCN,
      DialCode.POL,
      DialCode.PRT,
      DialCode.PRI,
      DialCode.QAT,
      DialCode.REU,
      DialCode.ROU,
      DialCode.RUS,
      DialCode.RWA,
      DialCode.BLM,
      DialCode.SHN,
      DialCode.KNA,
      DialCode.LCA,
      DialCode.MAF,
      DialCode.SPM,
      DialCode.VCT,
      DialCode.WSM,
      DialCode.SMR,
      DialCode.STP,
      DialCode.SAU,
      DialCode.SEN,
      DialCode.SRB,
      DialCode.SYC,
      DialCode.SLE,
      DialCode.SGP,
      DialCode.SXM,
      DialCode.SVK,
      DialCode.SVN,
      DialCode.SLB,
      DialCode.SOM,
      DialCode.ZAF,
      DialCode.KOR,
      DialCode.SSD,
      DialCode.ESP,
      DialCode.LKA,
      DialCode.SDN,
      DialCode.SUR,
      DialCode.SJM,
      DialCode.SWZ,
      DialCode.SWE,
      DialCode.CHE,
      DialCode.SYR,
      DialCode.TWN,
      DialCode.TJK,
      DialCode.TZA,
      DialCode.THA,
      DialCode.TGO,
      DialCode.TKL,
      DialCode.TON,
      DialCode.TTO,
      DialCode.TUN,
      DialCode.TUR,
      DialCode.TKM,
      DialCode.TCA,
      DialCode.TUV,
      DialCode.UGA,
      DialCode.UKR,
      DialCode.ARE,
      DialCode.GBR,
      DialCode.USA,
      DialCode.URY,
      DialCode.UZB,
      DialCode.VUT,
      DialCode.VEN,
      DialCode.VNM,
      DialCode.WLF,
      DialCode.ESH,
      DialCode.YEM,
      DialCode.ZMB,
      DialCode.ZWE,
      DialCode.DOM_1,
      DialCode.DOM_2,
      DialCode.DOM_3,
      DialCode.CUW,
    ]
  }
}
